import React, { Component} from 'react';
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import {Button} from '@material-ui/core';
import ApiCapaUsuariosCUIT from '../../Api/ApiCapaUsuariosCUIT.js';
import ApiCapaEmpleadoresCUIT from '../../Api/ApiCapaEmpleadoresCUIT.js';
import ApiEmpleador_X_CUIT from '../../Api/ApiEmpleador_X_CUIT.js';
import ApiRegistrarAcredito from '../../Api/ApiRegistrarAcredito.js';
import BootstrapTable from 'react-bootstrap-table-next';
import Capacitacion_DDJJ_PDF_Ventana from './Capacitacion_DDJJ_PDF_Ventana.js';
import moment from "moment";
import Modal from 'react-bootstrap/Modal'


export class Capacitacion_DDJJ extends Component {

    constructor(props) {
        super(props)

        this.CerrarVentanaImprimirDDJJ = this.CerrarVentanaImprimirDDJJ.bind(this);

        this.state = {
          modulos: [],
          capas: [],
          capacitaciones: [
            {
                dataField: 'IdCapa',
                text: '#',
                hidden: true,
            },  
            {
                dataField: 'Descripcion',
                text: 'Capacitación',
                editable: false, 
            }, 
            {
                dataField: 'Acredito',
                text: 'Acredito',
                formatter: this.Acreditar,
                
            }, 
            {
                dataField: 'Fecha',
                text: 'Fecha',
                editable: false, 
            }, 
          ],
          capaUsuarios: [],
          capaAcredita: [],
          modalPDFIsOpen: false,
          empleadorDatos: {},
          acreditaNroCapa: 0,
          modal: false,
          capaSeleccion: 0,
        }

        this.onFollowChanged.bind(this);
    }


    handleOpen = () => this.set({ modal: true,});

    handleClose = () => {
      console.log('handleClose');
      this.setState({ modal: false, acreditaNroCapa: 0,});
    }

    theme = createMuiTheme({
      palette: {
        primary:{
          light: '#83BC00',
          main: '#83BC00',
          dark: 'green',
          contrastText: '#fff',
      },
        secondary: green,
      },
    })
    
    componentDidMount(){ 

      //CONSULTO LOS DATOS DEL EMPLEADOR:
      ApiEmpleador_X_CUIT(this.props.CUIT)
      .then((response) => {
          if (response.data){
            console.log('ApiEmpleador_X_CUIT: ', response.status, response.data);

            this.setState({
              empleadorDatos: response.data,
            });

          }else{
            console.log('ERROR ApiEmpleador_X_CUIT!', response.status, response.data);
          }	
      },
      (error) => {
         console.log('error ApiEmpleador_X_CUIT: '+error);
      })


      let Modulos = [
          {Nro: 1,
          Descripcion: 'Riesgos  en los Establecimientos',
          },
          {Nro: 2,
            Descripcion: 'Normativa en H y Seguridad en el Trabajo',
          },
          {Nro: 3,
            Descripcion: 'Elementos de Protección Personal',
          },
          {Nro: 4,
            Descripcion: 'Productos Químicos y Biológicos',
          },
      ];
      this.setState({
        modulos: Modulos,
      });
     this.traerAcreditaciones();

    }  


    traerAcreditaciones = async() =>{

      let a = this.state.capas;
        a.push({IdCapa: 4, Descripcion: 'Modulo 1) Radiaciones UltraVioletas', Acredito: false, Fecha: ''})
        a.push({IdCapa: 7, Descripcion: 'Modulo 1) Manipulación Manual de Cargas', Acredito: false, Fecha: ''})
        a.push({IdCapa: 9, Descripcion: 'Modulo 1) Uso Seguro de la Motosierra', Acredito: false, Fecha: ''})
        a.push({IdCapa: 12, Descripcion: 'Modulo 1) Seguridad en la Oficina', Acredito: false, Fecha: ''})
        a.push({IdCapa: 1, Descripcion: 'Modulo 2) Capacitación COVID-19', Acredito: false, Fecha: ''})
        a.push({IdCapa: 2, Descripcion: 'Modulo 2) Botiquin', Acredito: false, Fecha: ''})
        a.push({IdCapa: 5, Descripcion: 'Modulo 2) Obstrucción de la vía aérea', Acredito: false, Fecha: ''})
        a.push({IdCapa: 10, Descripcion: 'Modulo 2) Fracturas - Primeros auxilios', Acredito: false, Fecha: ''})
        a.push({IdCapa: 14, Descripcion: 'Modulo 2) RCP en adultos, niños y bebés', Acredito: false, Fecha: ''})
        a.push({IdCapa: 6, Descripcion: 'Modulo 3) EPP Generalidades', Acredito: false, Fecha: ''})
        a.push({IdCapa: 8, Descripcion: 'Modulo 3) EPP para la aplicación de fitosanitarios', Acredito: false, Fecha: ''})
        a.push({IdCapa: 3, Descripcion: 'Modulo 4) Transporte Terrestre de Fitosanitarios', Acredito: false, Fecha: ''})
        a.push({IdCapa: 11, Descripcion: 'Modulo 4) Preparación y Carga de Fitosanitarios en Mochila', Acredito: false, Fecha: ''})
        a.push({IdCapa: 13, Descripcion: 'Modulo 4) Almacenamiento y depósito de fitosanitarios', Acredito: false, Fecha: ''})
        a.push({IdCapa: 15, Descripcion: 'Modulo 5) Riesgos Del Trabajo Parte 1', Acredito: false, Fecha: ''})
        a.push({IdCapa: 16, Descripcion: 'Modulo 5) Riesgos Del Trabajo Parte 2', Acredito: false, Fecha: ''})
        a.push({IdCapa: 17, Descripcion: 'Modulo 5) Riesgos Del Trabajo Parte 3', Acredito: false, Fecha: ''})

       //traigo las capacitacionesempleador para ver cuáles acreditó.
      await ApiCapaEmpleadoresCUIT(this.props.CUIT)
      .then((response) => {
        
        if (response.data){
          
          console.log('response.data-ACREDITACIONES: ',response.data)

          const acreditaciones = response.data.map(autoriz => {  
            
          
            if (autoriz.CapacitacionesId == 1){
                a[0] = {...a[0],Acredito:true, Fecha: autoriz.FechaAcredito} 
            };

            if (autoriz.CapacitacionesId == 2){
              a[1] = {...a[1],Acredito:true, Fecha: autoriz.FechaAcredito}
            };

            if (autoriz.CapacitacionesId == 3){
              a[2] = {...a[2],Acredito:true, Fecha: autoriz.FechaAcredito}
            };

            if (autoriz.CapacitacionesId == 4){
              a[3] = {...a[3],Acredito:true, Fecha: autoriz.FechaAcredito}
            };

            if (autoriz.CapacitacionesId == 5){
              a[4] = {...a[4],Acredito:true, Fecha: autoriz.FechaAcredito}
            };

            if (autoriz.CapacitacionesId == 6){
              a[5] = {...a[5],Acredito:true, Fecha: autoriz.FechaAcredito}
            };

            if (autoriz.CapacitacionesId == 7){
              a[6] = {...a[6],Acredito:true, Fecha: autoriz.FechaAcredito}
            };

            if (autoriz.CapacitacionesId == 8){
              a[7] = {...a[7],Acredito:true, Fecha: autoriz.FechaAcredito}
            };

            if (autoriz.CapacitacionesId == 9){
              a[8] = {...a[8],Acredito:true, Fecha: autoriz.FechaAcredito}
            };

            if (autoriz.CapacitacionesId == 10){
              a[9] = {...a[9],Acredito:true, Fecha: autoriz.FechaAcredito}
            };

            if (autoriz.CapacitacionesId == 11){
              a[10] = {...a[10],Acredito:true, Fecha: autoriz.FechaAcredito}
            };

            if (autoriz.CapacitacionesId == 12){
              a[11] = {...a[11],Acredito:true, Fecha: autoriz.FechaAcredito}
            };

            if (autoriz.CapacitacionesId == 13){
              a[12] = {...a[12],Acredito:true, Fecha: autoriz.FechaAcredito}
            };

            if (autoriz.CapacitacionesId == 14){
              a[13] = {...a[13],Acredito:true, Fecha: autoriz.FechaAcredito}
            };
            if (autoriz.CapacitacionesId == 15){
              a[14] = {...a[14],Acredito:true, Fecha: autoriz.FechaAcredito}
            };
            if (autoriz.CapacitacionesId == 16){
              a[15] = {...a[15],Acredito:true, Fecha: autoriz.FechaAcredito}
            };
            if (autoriz.CapacitacionesId == 17){
              a[16] = {...a[16],Acredito:true, Fecha: autoriz.FechaAcredito}
            };

          })
         this.setState({
            capas: a,
          });
      }
      },
      (error) => {
         console.log('error: '+error);
      })

    }

    traerEvaluaciones = async (e, row, rowIndex) => {   

      await ApiCapaUsuariosCUIT(this.props.CUIT)
      .then((response) => {
          if (response.data){
        
        let c = [];
        response.data.map(capa => {  
          if (capa.CapacitacionesId == row.IdCapa){
            c.push({
                Id: capa.CapacitacionesUsuariosId,
                CapaId: capa.CapacitacionesId, 
                Fecha: (moment(capa.FechaEvaluacion).format('DD-MM-YYYY')),
                CUIL: capa.UsuariosWeb.CUIT, NYA: capa.UsuariosWeb.Nombre,
                Calificacion: capa.Calificacion,
                Establecimiento: capa.RefEstablecimiento?.NroSucursal == 0 ? "" : capa.RefEstablecimiento?.NroSucursal+' - '+capa.RefEstablecimiento?.CodEstabEmpresa+' - '+capa.RefEstablecimiento?.DomicilioCalle +' '+capa.RefEstablecimiento?.DomicilioNro+' - '+capa.RefEstablecimiento?.SRTLocalidad?.NombreCompleto
              })
          };
        })

        this.setState({
          capaUsuarios: c,
        });

        //console.log('capas: ',c);

      }else{
        //console.log('ERROR!', response.status, response.data);
      }	
      },
      (error) => {
         //console.log('error: '+error);
      })
      
      this.setState({
        capaSeleccion: row.IdCapa,
      })
    }

    AbrirVentanaImprimirDDJJ () {

      this.setState({ modalPDFIsOpen: true });
   
    }

    onFollowChanged(row) {
      
      //console.log('onFollowChanged_IdCapa: '+row.IdCapa);
      this.setState({
        modal: true,
        acreditaNroCapa: row.IdCapa
      });
      
      //console.log(this.state.acredita);
    }

  
    Acreditar = (cell, row, rowIndex, formatExtraData) => {
      return (
        <ThemeProvider theme={this.theme}>
          <Button
            type="submit" 
            variant="contained" 
            color="primary" 
            disabled={row.Acredito ? true:false}
            onClick={() => {
              this.onFollowChanged(row);
            }}
          >
            Acreditar
          </Button>
        </ThemeProvider>
      );
    };

    async handleAcreditar(){
      var date = new Date();

      //console.log('handleAcreditar');
      const CapacitacionesEmpleador = {
        CUITEmpleador: this.props.CUIT,
        CapacitacionesId: this.state.acreditaNroCapa,
        Acredito: true,
        FechaAcredito: moment(date).format('YYYY-MM-DD'),
      }
      
     await ApiRegistrarAcredito(CapacitacionesEmpleador)
        .then((response) => {
            if (response.data){
                console.log('ApiRegistrarAcredito: ',response.data)
                
            }else{
              
            }	
            },
            (error) => {
                console.log('error: '+error);
            });
      this.handleClose();
      this.traerAcreditaciones();
    }

    CerrarVentanaImprimirDDJJ () {
      this.setState({ modalPDFIsOpen: false });
    };    
    
    renderSwitch(param) {
      switch(param) {
        case 'foo':
          return 'bar';
        default:
          return 'foo';
      }
    }
    
    render() {
      const CapacitacionesUsuarios = [
        {
          dataField: 'Id',
          text: '#',
          hidden: true,
        },             
        {
          dataField: 'CapaId',
          text: 'CapaId',   
          editable: false, 
          hidden: true,      
        }, 
        {
          dataField: 'Fecha',
          text: 'Fecha',   
          editable: false,
          headerStyle: { 'font-weight': 'normal'},          
        }, 
        {
          dataField: 'CUIL',
          text: 'CUIL',   
          editable: false,       
          headerStyle: { 'font-weight': 'normal'},   
        }, 
        {
          dataField: 'NYA',
          text: 'Nombre y Apellido',   
          editable: false,     
          headerStyle: { 'font-weight': 'normal'},     
        },
        {
          dataField: 'Calificacion',
          text: 'Calificación',   
          editable: false,     
          headerStyle: { 'font-weight': 'normal'},     
        },
        {
          dataField: 'Establecimiento',
          text: 'Establecimiento',   
          editable: false,     
          headerStyle: { 'font-weight': 'normal'},     
        },
      ];

      const rowEvents = {
         
          onClick: (e, row, rowIndex, ) => {
              console.log('rowEvents');
              this.traerEvaluaciones(e, row, rowIndex)
          },            
      };
      
      const rowStyle = (row, rowIndex) => {
        const style = {};
        style.fontSize = 12;
        return style;
      };


      const expandRow = {
        
        onlyOneExpanding: true,
        renderer: row => {
            console.log('tipo mov:'+row.IdCapa)
              return (
                <div style={{border: 'solid 1px black'}}>
                    <div>
                        <h4 style={{fontSize: 'larger'}}>Evaluaciones de Empleados:</h4>
                        <BootstrapTable
                            keyField='Id' 
                            data={ this.state.capaUsuarios }
                            columns={ CapacitacionesUsuarios }  
                            rowStyle={rowStyle}   
                            noDataIndication="No hay datos para mostrar"
                            striped 
                        />
                    </div>
                </div>
              )
        }
      };

      return (
          <>
            
            {
              <Modal show={this.state.modal} onHide={this.handleClose}>
              
                  <Modal.Header closeButton>
                    <Modal.Title>Acreditar</Modal.Title>
                  </Modal.Header>
                  {console.log('this.state.capaSeleccion: '+this.state.capaSeleccion)}

                  {(() => {switch (this.state.capaSeleccion) {
                    case 1:
                      return <Modal.Body>Va a acreditar la capacitación: Modulo 2 - Capacitación COVID-19 </Modal.Body>

                    case 2:
                      return <Modal.Body>Va a acreditar la capacitación: Modulo 2 - Botiquin </Modal.Body>

                    case 3:
                      return <Modal.Body>Va a acreditar la capacitación: Modulo 4 - Transporte Terrestre de Fitosanitarios</Modal.Body>
 
                    case 4:
                      return <Modal.Body>Va a acreditar la capacitación: Modulo 1 - Radiaciones UltraVioletas</Modal.Body> 

                    case 5:
                      return <Modal.Body>Va a acreditar la capacitación: Modulo 2 - Obstrucción de la vía aérea</Modal.Body>

                    case 6:
                      return <Modal.Body>Va a acreditar la capacitación: Modulo 3 - EPP Generalidades</Modal.Body>

                    case 7:
                      return <Modal.Body>Va a acreditar la capacitación: Modulo 1 - Manipulación Manual de Cargas</Modal.Body>

                    case 8:
                      return <Modal.Body>Va a acreditar la capacitación: Modulo 3 - EPP para la aplicación de fitosanitarios</Modal.Body>

                    case 9:
                    return <Modal.Body>Va a acreditar la capacitación: Modulo 1 - Uso Seguro de la Motosierra</Modal.Body>

                    case 10:
                      return <Modal.Body>Va a acreditar la capacitación: Modulo 2 - Fracturas - Primeros auxilios</Modal.Body>
                      
                    case 11:
                      return <Modal.Body>Va a acreditar la capacitación: Modulo 4 - Preparación y Carga de Fitosanitarios en Mochila</Modal.Body>

                    case 12:
                      return <Modal.Body>Va a acreditar la capacitación: Modulo 1 - Seguridad en la Oficina</Modal.Body>

                    case 13:
                      return <Modal.Body>Va a acreditar la capacitación: Modulo 4 - Almacenamiento y depósito de fitosanitarios</Modal.Body>
                      
                    case 14:
                      return <Modal.Body>Va a acreditar la capacitación: Modulo 2 - RCP en adultos, niños y bebés</Modal.Body>

                    case 15:
                      return <Modal.Body>Va a acreditar la capacitación: Riesgos del Trabajo Parte 1</Modal.Body>

                    case 16:
                      return <Modal.Body>Va a acreditar la capacitación: Riesgos del Trabajo Parte 2</Modal.Body>

                     case 17:
                      return <Modal.Body>Va a acreditar la capacitación: Riesgos del Trabajo Parte 3</Modal.Body>



                    default:
                      break;
                  }})()}

                  {/*this.state.capaSeleccion == 1 ? 
                  <Modal.Body>Va a acreditar la capacitación: Modulo 2 - Capacitación COVID-19 </Modal.Body>
                  :
                  <Modal.Body>Va a acreditar la capacitación: Modulo 2 - Botiquin </Modal.Body>
                  */}
                  <Modal.Footer>
                    <Button color="secondary"  type="submit" variant="contained"  onClick={this.handleClose}>
                        Cerrar
                    </Button>
                    <Button  type="submit" variant="contained" onClick={() => this.handleAcreditar()}>
                        Acreditar
                    </Button>
                  </Modal.Footer>
              </Modal>
            }

            <div className="container" style={{marginTop: '10%'}}>
               <a style={{borderBottom: '5px solid #F8A700'}}>CAPACITACIONES </a>
                
               <BootstrapTable 
                    keyField="IdCapa"
                    data={ this.state.capas } 
                    columns={ this.state.capacitaciones } 
                    noDataIndication="No hay datos para mostrar" 
                    //selectRow={selectRow}
                    rowEvents={rowEvents}
                    expandRow={expandRow}
                    striped
                    hover
               />

            <ThemeProvider theme={this.theme}>
              <Button type="submit" variant="contained" color="primary" disabled={this.state.capaUsuarios.length > 0 ? false:true} onClick={() => this.AbrirVentanaImprimirDDJJ()}>
                  Imprimir DDJJ
              </Button>
            </ThemeProvider>


            </div>

            <div>
             {this.state.modalPDFIsOpen ?
                    <Capacitacion_DDJJ_PDF_Ventana  
                       modalPDFIsOpen={this.state.modalPDFIsOpen}
                       capacitaciones={this.state.capaUsuarios}
                       empleadorDatos={this.state.empleadorDatos}
                       handleCerrarVentanaImpresion={this.CerrarVentanaImprimirDDJJ}
                       capaSeleccion={this.state.capaSeleccion}
                    />
                :
                    null
                }
            </div>
            </>
        )
      }
    }

export default Capacitacion_DDJJ;
